<div [formGroup]="parentGroup">
  <bolt-select [name]="inputFormControl" ngDefaultControl [formControlName]='inputFormControl' [label]="label"
    [attr.error]='nwInputErrorService.validateBoltTextfield(parentGroup,inputFormControl)'
    [id]="inputFormControl" [attr.aria-describedby]="'label_'+inputFormControl"
    [attr.aria-labelledby]="'label_'+inputFormControl" [required]='required' [attr.required]="required">
    @for (options of optionValues; track options) {
      <option value="{{options.value}}">{{options.caption}}</option>
    }
    @for (options of additionalValues; track options) {
      <option value="{{options.value}}">{{options.caption}}</option>
    }
  </bolt-select>
</div>
